import React from 'react'
import { bool, shape, func, string } from 'prop-types'
import { useSelector } from 'react-redux'
import PassengerForm from './PassengerForm'
import RowGroup from '../RowGroup/RowGroup'
import { selectPaymentFerryId } from '../../redux/paymentConfirmation/selectors'
import {
  selectDepartureRoute,
  selectReturnRoute
} from '../../redux/ferryRouteSelections/selectors'
import { getPassengerLabelKeysFromPassengerType } from '../../configuration/utilities'

const PassengerDetailsForm = ({
  fieldDetails,
  labels,
  values,
  disabled,
  setFieldValue,
  onBlur,
  parentKey
}) => {
  const rowLabels = {}
  const paymentFerryId = useSelector(selectPaymentFerryId)

  const departureRoute = useSelector(selectDepartureRoute)
  const returnRoute = useSelector(selectReturnRoute)
  const allPassengerOptions = [
    ...(departureRoute?.passengerTypes || []),
    ...(departureRoute?.walkOnPassengerTypes || []),
    ...(returnRoute?.passengerTypes || []),
    ...(returnRoute?.walkOnPassengerTypes || [])
  ]
  Object.keys(values).forEach(passengerId => {
    const passengerConfig = allPassengerOptions.find(
      ({ type }) => type === values[passengerId]?.passengerType
    )
    const description =
      labels?.[
        getPassengerLabelKeysFromPassengerType(
          values[passengerId]?.passengerType
        )?.default
      ] || passengerConfig?.description

    let tripTypePrefix

    if (values[passengerId]?.type) {
      if (values[passengerId].type === 'departures' && labels.departureRoute) {
        tripTypePrefix = labels.departureRoute
      }
      if (values[passengerId].type === 'returns' && labels.returnRoute) {
        tripTypePrefix = labels.returnRoute
      }
    }
    rowLabels[
      passengerId
    ] = `${tripTypePrefix} - ${description} ${passengerId.substring(
      passengerId.lastIndexOf('-') + 1
    )}`
  })

  return (
    <RowGroup
      title={labels.passengerDetails}
      convertInputsToCaps
      render={({ formRowClasses, errorClasses }) => (
        <PassengerForm
          fieldDetails={fieldDetails}
          disabled={disabled}
          values={values}
          rowLabels={rowLabels}
          setFieldValue={setFieldValue}
          formRowClasses={formRowClasses}
          errorClasses={errorClasses}
          paymentFerryId={paymentFerryId}
          onBlur={onBlur}
          parentKey={parentKey}
          labels={labels}
        />
      )}
    />
  )
}

PassengerDetailsForm.propTypes = {
  fieldDetails: shape().isRequired,
  labels: shape().isRequired,
  disabled: bool.isRequired,
  values: shape().isRequired,
  setFieldValue: func.isRequired,
  duplicatePassengerQuantities: bool,
  onBlur: func,
  parentKey: string
}

export default PassengerDetailsForm
